import React from 'react';
import { Form, Icon, Input, Button } from 'antd';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Nav from '../components/Nav';
import { isAuthenticated } from '../redux/util';

const FormItem = Form.Item;

const invokeLogin = async creds => {
  const res = await fetch(
    `${process.env.REACT_APP_DRAFTFAST_API}/rest-auth/login/`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: creds.userName,
        password: creds.password,
      }),
    },
  );

  return res;
};

class LoginForm extends React.Component {
  state = {
    authenticated: false,
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const res = await invokeLogin(values);

        let key;
        let failedCreds = true;

        const authenticated = res.status === 200;
        if (authenticated) {
          ({ key } = await res.json());
          failedCreds = false;
        }

        localStorage.setItem('dfast_val', key);
        this.setState({
          authenticated,
          failedCreds,
        });

        this.props.authenticate({
          username: values.userName,
        });
      }
    });
  };

  render() {
    if (this.state.authenticated) {
      return <Redirect to="/" />;
    }

    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Nav />
        <div className="login-wrapper">
          <div className="login-form">
            <Form
              onSubmit={this.handleSubmit}
              layout="vertical"
              className="login-form"
            >
              <h3>DraftFast Log In</h3>
              <br />
              <FormItem>
                {getFieldDecorator('userName', {
                  rules: [
                    { required: true, message: 'Please input your username.' },
                  ],
                })(
                  <Input
                    prefix={
                      <Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    placeholder="Username"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('password', {
                  rules: [
                    { required: true, message: 'Please input your password.' },
                  ],
                })(
                  <Input
                    prefix={
                      <Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    type="password"
                    placeholder="Password"
                  />,
                )}
              </FormItem>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Login
              </Button>
              {this.state.failedCreds && (
                <div>
                  <br />
                  <div>Invalid username or password</div>
                </div>
              )}
            </Form>
            <b>
              Interested in free DraftFast premium access? E-mail me at
              ben.brostoff@gmail.com and I'll upgrade your account! Users
              will get to beta test new features as they're released. Offer
              limited to end of September.
            </b>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { authenticated: state && state.authenticated };
};

const mapDispatchToProps = dispatch => ({
  authenticate: id => dispatch(isAuthenticated(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  Form.create()(LoginForm),
);



// WEBPACK FOOTER //
// ./src/user/Login.js